import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import $api from "../../api/$api";
import { TDataToken, TQueries } from "./type";

export const getOrgTreeData = (data: TDataToken, queries) => {
  return $api
    .get(`/org-tree`, { token: data.accessToken, params: { ...queries } })
    .then((response) => {
      return response;
    });
};

export const useGetOrgTreeData = (data: TDataToken, queries:TQueries, config?: {}) => {
  return useQuery({
    queryKey: ["orgtree", queries],
    staleTime: 1000 * 60 * 1,
    queryFn: () => getOrgTreeData(data, queries),
    ...config as UseQueryOptions<any>
  });
};